import { ItemType } from '../../constants';
import { normalizeItemArray, normalizeItemMap } from '../../utils';
import { AddCommandEvent, ItemsData, PasteCommandEvent, RemoveCommandEvent } from '../../types';

export const parseAddedItems = ({ params }: AddCommandEvent): ItemsData => {
  const { model, type } = params;
  const data = normalizeItemArray([model]);

  return {
    nodes: type === ItemType.Node ? data : [],
    edges: type === ItemType.Edge ? data : [],
  };
};

export const parseDeletedItems = ({ params }: RemoveCommandEvent): ItemsData => {
  const { nodes: deletedNodes, edges: deletedEdges } = params.flow;

  return {
    nodes: normalizeItemMap(deletedNodes),
    edges: normalizeItemMap(deletedEdges),
  };
};

export const parsePastedItems = ({ params }: PasteCommandEvent): ItemsData => {
  return {
    nodes: normalizeItemArray(params.models),
    edges: [],
  };
};
